import { gql, useQuery } from "@apollo/client";
import { useMemo } from "react";

export interface PriceListRoute {
  code: string;
  name: string;
  seaAreaName: string;
  routePairCode: string;
  routeType: string;
}

interface PriceListRouteFilterQueryResult {
  productPrice: {
    route: {
      byRouteTypes: Array<{
        id: string;
        code: string;
        name: string;
        routeType: string;
        routePair: {
          id: string;
          code: string;
          seaArea: {
            id: string;
            name: string;
          };
        };
      }>;
    };
  };
}

export const priceListRouteFilterQuery = gql`
  query PriceListRouteFilter(
    $routeTypes: [String!]!
    $excludeOnlyAsPartOfMultiLegRoutes: Boolean!
    $includeNotValid: Boolean!
  ) {
    productPrice {
      route {
        byRouteTypes(
          routeTypes: $routeTypes
          excludeOnlyAsPartOfMultiLegRoutes: $excludeOnlyAsPartOfMultiLegRoutes
          includeNotValid: $includeNotValid
        ) {
          id
          code
          name
          routeType
          routePair {
            id
            code
            seaArea {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const useFetchPriceListRoutes = () => {
  const { data, loading, error } = useQuery<PriceListRouteFilterQueryResult>(
    priceListRouteFilterQuery,
    {
      variables: {
        routeTypes: ["O", "P"],
        excludeOnlyAsPartOfMultiLegRoutes: false,
        includeNotValid: false,
      },
      fetchPolicy: "cache-first",
    }
  );

  const routes = useMemo<PriceListRoute[]>(
    () =>
      (data?.productPrice.route.byRouteTypes ?? []).map((route) => ({
        code: route.code,
        name: route.name,
        seaAreaName: route.routePair.seaArea.name,
        routePairCode: route.routePair.code,
        routeType: route.routeType,
      })),
    [data]
  );

  return { routes, loading, error };
};
